import { FC } from "react";
import { Link } from "react-router-dom";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Breadcrumbs as MBreadcrumbs, Text } from "@mantine/core";

import styles from "./Breadcrumbs.module.css";

export interface BreadcrumbItem {
  title: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <MBreadcrumbs
      separator={
        <FontAwesomeIcon
          icon={faChevronRight}
          size="xs"
          fontWeight={600}
          color="dark.4"
        />
      }
      classNames={{ separator: styles.separator }}
    >
      {items.map((item, i) => {
        return item.href ? (
          <Anchor
            component={Link}
            to={item.href}
            key={item.title}
            classNames={{ root: styles.anchor }}
            c="dark.4"
          >
            {item.title}
          </Anchor>
        ) : (
          <Text
            fw={600}
            size={"12px"}
            c="dark.4"
            key={i}
            classNames={{ root: styles.text }}
          >
            {item.title}
          </Text>
        );
      })}
    </MBreadcrumbs>
  );
};
